// Components==============
import Shade from 'components/UI/Shade';
import { motion } from 'framer-motion';
import React from 'react';
import { useLocation } from 'react-router';
import { encodeURL } from 'utilities/encodeURL';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useScrollFreeze } from 'utilities/useScrollFreeze';
import './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
// =========================

const Component = ({ closeModal, color, image, imageText, children }) => {
    useScrollFreeze();

    const closeUrlModal = useCloseUrlModal();
    const close = closeModal || closeUrlModal;

    return (
        <motion.div
            styleName="container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div styleName="overflow-hidden">
                <div
                    styleName={`wrapper ${color === '#2db1d8' ? 'blue' : ''} ${
                        color === '#9879c3' ? 'purple' : ''
                    } ${color === '#f4bb56' ? 'yellow' : ''} ${
                        color === '#3f3f93' ? 'dark-purple' : ''
                    } ${color === '#1e265c' ? 'primary' : ''}`}
                >
                    {image && (
                        <div styleName="relative">
                            <img src={image} alt="modal" />
                            {imageText && <h2>{imageText}</h2>}
                        </div>
                    )}
                    <div styleName="content">{children}</div>
                </div>
            </div>
            <FontAwesomeIcon
                styleName="close-icon"
                onClick={close}
                icon={faXmark}
            />
            <Shade color={color} onClick={close} />
        </motion.div>
    );
};

export default function Modal(props) {
    const { slug, closeModal, exact } = props;

    const { pathname } = useLocation();

    if (
        closeModal ||
        (exact
            ? pathname.includes('popup') && pathname === encodeURL(slug)
            : pathname.includes('popup') && pathname.includes(encodeURL(slug)))
    )
        return <Component {...props} />;

    return <></>;
}
